﻿import { Card } from "antd";
import styled from "styled-components";

export const MilestoneTemplateLayoutCard = styled(Card)`
  min-width: 280px;
`;
